export default "__VITE_ASSET__b653e9e0__"